import React from 'react'
import numeral from 'numeral'
import { compose, withState, lifecycle, withHandlers } from 'recompose'
import { FormattedMessage } from 'react-intl'

const seconds = 60

let TimerEl = ({ elapsed }) => (
  <span className='Text Signin__timer' style={{opacity: elapsed === 0 && 0}}>
    <FormattedMessage id='timer.repeat_in' />
    {' '}
    0:{numeral(elapsed).format('00')}
  </span>
)

TimerEl = compose(
  lifecycle({
    componentDidMount () {
      this.timer = setInterval(() => {
        this.props.updateTimer()
        if (this.props.elapsed <= 0) clearInterval(this.timer)
      }, 1000)
    },
    componentWillUnmount () {
      clearInterval(this.timer)
    },
    componentWillReceiveProps (np) {
      if (np.elapsed === seconds) {
        this.timer = setInterval(() => {
          this.props.updateTimer()
          if (this.props.elapsed <= 0) clearInterval(this.timer)
        }, 1000)
      }
    }
  })
)(TimerEl)

const Timer = ({ elapsed, setElapsed, resendCode, clear, noBack }) => (
  <span>
    {(elapsed > 0) && <TimerEl updateTimer={setElapsed} elapsed={elapsed} />}
    {(elapsed <= 0) && (<a className='Text Signin__timer' onClick={resendCode}><FormattedMessage id='timer.resend' /></a>)}
    {!noBack && (
      <button className='_backButton' onClick={clear}>
        <FormattedMessage id='timer.back' />
      </button>
    )}
    {/* Button_black_transparent Signin__back */}
  </span>
)

export default compose(
  withState('elapsed', 'setElapsed', seconds),
  withHandlers({
    setElapsed: ({ setElapsed, elapsed }) => () => {
      let value = elapsed - 1
      setElapsed(value)
    },
    resendCode: ({ sendCode, setElapsed }) => async () => {
      await sendCode()
      setElapsed(seconds)
    }
  })
)(Timer)



// WEBPACK FOOTER //
// ./src/components/SIgn/Timer.jsx